import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { posSales: { getPosSales } } = apiUrls;

export const POS_SALES_SUCCESS = 'POS_SALES_SUCCESS';
export const POS_SALES_LOADING = 'POS_SALES_LOADING';


export const getPosSalesData = () => async (dispatch) => {
        try {
            const { url } = getPosSales
            const requestData = {
                ...getPosSales, url: getPosSales.url,                
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: POS_SALES_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: POS_SALES_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                },
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {    
    dispatch({
        type: POS_SALES_LOADING,
        isLoading,
    })
}
